import dateTimeHelper from '../Helpers/datetimeHelper';

export default class OpenAiChatSessionItem {
  constructor(item) {
    if (item === undefined) {
      this.SessionId = '';
      this.Messages = [];
      this.UserId = '';
      this.SessionName = '';
      this.OpenAiChatMessages = [];
      this.LastUpdatedUtc = dateTimeHelper.GetCurrentDateTime();
      this.Model = '-';
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.SessionId = item.sessionId;
    this.UserId = item.userId;
    this.SessionName = item.sessionName;
    this.OpenAiChatMessages = item.openAiChatMessages;
    this.LastUpdatedUtc = item.lastUpdatedUtc;
    this.Model = item.model;
  }
}
